<template>
  <div>
    <v-slide-group class="my-6" show-arrows>
      <v-slide-item
        class="magazine mr-6"
        v-for="({ img, title, to }, i) in items"
        :key="i"
      >
        <v-card width="270px" :href="to" target="_blank" tile>
          <img :src="img + '?resize=1&w=270'" :alt="title" />
        </v-card>
      </v-slide-item>
    </v-slide-group>

    <div class="text-center">
      <v-btn
        class="mb-10 px-10 text-none rounded-pill text-body-1"
        color="primary"
        height="56px"
        to="revista"
        depressed
      >
        Veja todas as Edições
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    items() {
      if (!this.$rest("magazine").list.length) return "";

      return this.$rest("magazine").list.map(({ id, img, title }) => ({
        img: this.files + img,
        title,
        to: `https://revista.revistanoticiamt.com.br/${id}`,
      }));
    },
  },
  created() {
    this.$rest("magazine").get({ params: { itemsPerPage: 20 } });
  },
};
</script>

<style scoped>
.magazine img {
  aspect-ratio: 270 / 350;
  display: block;
  object-fit: cover;
  -o-object-fit: cover;
  object-position: center;
  -o-object-position: center;
  width: 100%;
}
</style>
